import React, { useState, useEffect } from 'react';
import { MessageCircle, X, ChevronLeft, ArrowRight, Phone } from 'lucide-react';

// WhatsApp Floating Bar Component - PRIVIA Design
const ConciergeChat = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const phoneNumber = "+17868400745";
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=Bonjour! Je souhaite obtenir des informations sur vos villas de luxe.`;

  // Handle scroll effect like navigation
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    window.open(whatsappUrl, '_blank');
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className={`transition-all duration-500 ease-out ${isExpanded ? 'w-80' : 'w-auto'}`}>
        <div className={`rounded-sm shadow-2xl backdrop-blur-md ring-1 transition-all duration-500 ${
          isScrolled 
            ? 'bg-white/95 text-gray-900 border-2 border-gray-200/50 ring-black/5' 
            : 'bg-white/10 text-white border-2 border-white/20 ring-white/10'
        }`}>
          {!isExpanded ? (
            // Collapsed State - Elegant Bar
            <button
              onClick={toggleExpand}
              className={`flex items-center space-x-3 px-6 py-4 transition-all duration-300 group rounded-sm ${
                isScrolled 
                  ? 'hover:bg-gray-100/50' 
                  : 'hover:bg-white/20'
              }`}
            >
              <div className="flex items-center space-x-3">
                <div className={`w-2 h-2 rounded-full animate-pulse opacity-60 ${
                  isScrolled ? 'bg-gray-900' : 'bg-white'
                }`}></div>
                <MessageCircle className={`w-5 h-5 transition-colors drop-shadow-sm ${
                  isScrolled 
                    ? 'text-gray-900 group-hover:text-gray-700' 
                    : 'text-white group-hover:text-white'
                }`} />
                <span className={`text-sm font-medium tracking-wide uppercase transition-colors drop-shadow-sm ${
                  isScrolled 
                    ? 'text-gray-900 group-hover:text-gray-700' 
                    : 'text-white group-hover:text-white'
                }`}>
                  Talk to a Specialist
                </span>
              </div>
              <ChevronLeft className={`w-4 h-4 transition-all transform group-hover:-translate-x-1 drop-shadow-sm ${
                isScrolled 
                  ? 'text-gray-600 group-hover:text-gray-700' 
                  : 'text-white/80 group-hover:text-white'
              }`} />
            </button>
          ) : (
            // Expanded State - Full Content
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <div className={`w-2 h-2 rounded-full animate-pulse opacity-60 ${
                    isScrolled ? 'bg-gray-900' : 'bg-white'
                  }`}></div>
                  <span className={`text-xs font-light tracking-[0.2em] uppercase ${
                    isScrolled ? 'text-gray-600' : 'text-white/70'
                  }`}>Available Now</span>
                </div>
                <button 
                  onClick={toggleExpand}
                  className={`transition-colors p-1 ${
                    isScrolled 
                      ? 'text-gray-500 hover:text-gray-700' 
                      : 'text-white/50 hover:text-white/80'
                  }`}
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
              
              <div className="mb-6">
                <h4 className={`text-lg font-light mb-2 tracking-wide ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}>
                  Parlez à un Spécialiste Villa
                </h4>
                <p className={`text-sm font-light leading-relaxed ${
                  isScrolled ? 'text-gray-600' : 'text-white/60'
                }`}>
                  Obtenez des conseils d'expert sur votre villa de rêve de la part de Christopher Warren
                </p>
              </div>
              
              <button
                onClick={handleWhatsAppClick}
                className={`w-full rounded-sm py-4 px-4 flex items-center justify-center space-x-3 transition-all duration-300 group backdrop-blur-sm border ${
                  isScrolled 
                    ? 'bg-gray-900/5 hover:bg-gray-900/10 border-gray-900/10 hover:border-gray-900/20' 
                    : 'bg-white/5 hover:bg-white/10 border-white/10 hover:border-white/20'
                }`}
              >
                <MessageCircle className={`w-5 h-5 group-hover:scale-110 transition-all ${
                  isScrolled 
                    ? 'text-gray-700 group-hover:text-gray-900' 
                    : 'text-white/80 group-hover:text-white'
                }`} />
                <span className={`text-sm font-light tracking-wide ${
                  isScrolled 
                    ? 'text-gray-800 group-hover:text-gray-900' 
                    : 'text-white/90 group-hover:text-white'
                }`}>
                  Démarrer une Conversation WhatsApp
                </span>
                <ArrowRight className={`w-4 h-4 group-hover:translate-x-1 transition-all ${
                  isScrolled 
                    ? 'text-gray-600 group-hover:text-gray-900' 
                    : 'text-white/60 group-hover:text-white'
                }`} />
              </button>
              
              <div className={`mt-4 pt-4 border-t ${
                isScrolled ? 'border-gray-900/10' : 'border-white/10'
              }`}>
                <div className={`flex items-center justify-center space-x-2 text-xs font-light ${
                  isScrolled ? 'text-gray-500' : 'text-white/50'
                }`}>
                  <Phone className="w-3 h-3" />
                  <span>+1 786 840 0745</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConciergeChat;
